import { t } from 'i18next';
import { Button } from 'primereact/button';

type GetPaginatorTemplateProps = {
  onNext: () => void;
  onPrev: () => void;
  totalRecords: number;
  skip: number;
  rowsPerPage: number;
};

export const getPaginatorTemplate = ({
  onNext,
  onPrev,
  totalRecords,
  skip,
  rowsPerPage,
}: GetPaginatorTemplateProps) => {
  const first = skip + 1;
  const last = Math.min(skip + rowsPerPage, totalRecords);

  return {
    layout: 'CurrentPageReport PrevPageLink NextPageLink',
    CurrentPageReport: () => {
      return (
        <div className='flex flex-row gap-2 mr-2'>
          <div className='flex flex-row gap-1'>
            <span>{totalRecords > 0 ? first : 0}</span>
            <span>-</span>
            {last}
          </div>
          <span>{t('global.of')}</span>
          <span>{totalRecords}</span>
        </div>
      );
    },
    PrevPageLink: () => {
      return (
        <Button
          icon='pi pi-chevron-left text-sm'
          className='p-paginator-prev'
          onClick={onPrev}
          disabled={skip <= 0}
        />
      );
    },
    NextPageLink: () => {
      return (
        <Button
          icon='pi pi-chevron-right text-sm'
          className='p-paginator-next'
          onClick={onNext}
          disabled={skip + rowsPerPage >= totalRecords}
        />
      );
    },
  };
};
